export const translations = {
  ru_RU: {
    HEADER: {
      DROP_DOWN_ITEMS: {
        PROFILE: "Личный кабинет",
        CHOOSE_ORGANIZATION: "К списку организаций",
      },
    },
    CONTENT: {
      ERROR_PAGE_DICTIONARY: {
        ERROR_TEXT: "Не можем показать страницу",
        DESCRIPTION_TEXT: "Проблема уже в работе, и её скоро решат.",
        SUGGESTION_TEXT: "Попробуйте обновить страницу или зайти чуть позже",
        BUTTON_TEXT: "Обновить",
      },
    },
  },
  en: {
    HEADER: {
      DROP_DOWN_ITEMS: {
        PROFILE: "Profile",
        CHOOSE_ORGANIZATION: "Choose organization",
      },
    },
    CONTENT: {
      ERROR_PAGE_DICTIONARY: {
        ERROR_TEXT: "Can't display the page",
        DESCRIPTION_TEXT:
          "The issue is already being addressed and will be resolved soon.",
        SUGGESTION_TEXT: "Try refreshing the page or come back later.",
        BUTTON_TEXT: "Refresh",
      },
    },
  },
} as const;
